import React, { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../providers/auth";
import { SettingsContext } from "../../providers/settings";
import HomePageLayout from "../../layouts/HomePage/HomePageLayout";
import { Grid, Stack, Box, GTIWebSelect, GTIWebDataGrid, GTIWebButton } from "@gti-controls-v2/web-core";
import Title from "../../components/title";
import useLookup from "../../hooks/useLookups";
import useSearch from "../../hooks/useSearch";
import { paths } from "../../common/constants/Rutas";
import homePageStyles from "../../common/styles/HomePage";
import DateRangeFilter from "../../components/date-range-filter";
import { formatDate } from "../../common/utilities/dataFormat";

export const HomePage = () => {
    const dateFormat = "DD/MMM/YYYY";
    const today = new Date();
    const lastYear = new Date(today);
    lastYear.setFullYear(today.getFullYear() - 1);
    const initDateRangePicker = {startDate: lastYear, endDate: today };
    const styles = homePageStyles;
    const navigate = useNavigate();
    const { user } = useContext(AuthContext);
    const { handleLoading, isLoading } = useContext(SettingsContext);
    const { getUsuariosSoporte, getTicketStatus } = useLookup();
    const { getLastTickets } = useSearch();
    const [isAdmin, setIsAdmin] = useState(false);
    const [usuariosSoporte, setUsuariosSoporte] = useState(null);
    const [selectedUsuario, setSelectedUsuario] = useState(0);
    const [statusTicket, setStatusTicket] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState("0");
    const [dateTicket, setDateTicket] = useState({
        startDate: formatDate(lastYear),
        endDate: formatDate(today)
    });
    const [tickets, setTickets] = useState([]);

    useEffect(() => {
        handleLoading(true);
        setIsAdmin(user?.roles.adminSoporte);
        getUsuarioSoporteHandler();
        getTicketStatusHandler();
        handleLoading(false);

        // eslint-disable-next-line
    }, [user]);

    useEffect(() => {
        handleLoading(true);
        let formattedDateTicket = dateTicket;
        
        if (dateTicket && typeof dateTicket === 'object') {
            const startDateNeedsFormat = dateTicket.startDate instanceof Date;
            const endDateNeedsFormat = dateTicket.endDate instanceof Date;
                
            if (startDateNeedsFormat || endDateNeedsFormat) {
                formattedDateTicket = {
                    startDate: startDateNeedsFormat ? formatDate(dateTicket.startDate) : dateTicket.startDate,
                    endDate: endDateNeedsFormat ? formatDate(dateTicket.endDate) : dateTicket.endDate
                };
                setDateTicket(formattedDateTicket);
                return;
            }
        }
        
        if (isAdmin && selectedUsuario && selectedStatus.toString().length > 0 && formattedDateTicket) {
            getLastTicketsHandler(selectedUsuario, selectedStatus, formattedDateTicket);
        }

        if (!isAdmin && user?.usuarioID) {
            getLastTicketsHandler(user?.usuarioID, selectedStatus, formattedDateTicket);
        }
        handleLoading(false);
        // eslint-disable-next-line
    }, [selectedUsuario, selectedStatus, dateTicket]);

    const handlerOnChange = (e) => {
        switch (e.target.name) {
            case "statusTicket":
                setSelectedStatus(e.target.value);
                break;
            case "usuarioSoporte":
                setSelectedUsuario(e.target.value);
                break;
            case "dateRange":
                setDateTicket(e.target.value);
                break;
            default:
                break;
        }
    };

    const getUsuarioSoporteHandler = async () => {
        const usersSoporte = await getUsuariosSoporte();
        setUsuariosSoporte(usersSoporte.data);
    };

    const getTicketStatusHandler = async () => {
        const result = await getTicketStatus();
        setStatusTicket(result.data);
    };

    const getLastTicketsHandler = async (usuarioId, status, dates) => {
        handleLoading(true);
        const result = await getLastTickets(usuarioId, status, dates.startDate, dates.endDate);

        if (result?.exitoso) {
            setTickets(result?.data || []);
        }
        handleLoading(false);
    };

    const columns = [
        { field: "id",      headerName: "No.",         width: 80, },
        { field: "nombre",  headerName: "Nombre",      width: 150, showPopper: true },
        { field: "ape",     headerName: "Apellidos",   width: 150, showPopper: true },
        { field: "motivo",  headerName: "Motivo",      width: 150, showPopper: true },
        { field: "fecha",   headerName: "Fecha",       width: 150, align: 'left' },
    ];

    const columnsPanel = [
        [{
            field: "observa",
            label: "Observaciones"
        }],
        [{
            field: "statusDesc",
            label: "Estatus"
        }]
    ];

    const onClickContinuar = (e, record) => {
        navigate(paths.TicketPage, { state: { ...record, TicketID: record.id }})
    };

    const detailPanelContentProp = (data, schema) => (
        <Grid container >
            {
                schema.length > 0 && schema.map((column, key_column) => {
                    return (
                        <Grid item xs={6} key={key_column}>
                            {
                                column.map((row, key_row) => {
                                    return (
                                        <Stack xs={12} key={key_row} padding={4} spacing={2} direction={"row"} alignItems="center">
                                            <Box sx={{ fontWeight: 500 }}>
                                                {`${row.label}: `}
                                            </Box>
                                            <Box>
                                                {
                                                    data["statusId"] === 1 && row.field === "statusDesc" ? (
                                                        <GTIWebButton
                                                            name="continuar"
                                                            type="submit"
                                                            text="Continuar"
                                                            sx={styles.btnContinue}
                                                            onClick={(e) => onClickContinuar(e, data)}
                                                        />
                                                    ) :
                                                        `${data[row.field]}`
                                                }
                                            </Box>
                                        </Stack>
                                    );
                                })
                            }
                        </Grid>
                    );
                })
            }
        </Grid>
    );

    return (
        <HomePageLayout>
            <Stack direction="column" spacing={2} align="left" paddingBottom={10}>
                <Title>Últimos Tickets</Title>

                {
                    isAdmin ?
                        <Box>

                            <GTIWebSelect
                                name="usuarioSoporte"
                                dataSource={usuariosSoporte}
                                displayedValue="UsuarioName"
                                selectedValue="UsuarioID"
                                labelText="Seleccionar Usuario:"
                                color={"secondary"}
                                disableDefaultReadOnly
                                width={300}
                                onChange={handlerOnChange}
                            />
                        </Box> : null
                }
            </Stack>

            <Stack direction="row" spacing={4} align="left" paddingBottom={4}>
                <Box>
                    <GTIWebSelect
                        name="statusTicket"
                        labelText="Estado del ticket:"
                        dataSource={statusTicket}
                        displayedValue="statusDesc"
                        selectedValue="id"
                        color={"secondary"}
                        disableDefaultReadOnly
                        width={250}
                        onChange={handlerOnChange}
                    />
                </Box>

                <Box sx={styles.supportDatePicker}>
                    <DateRangeFilter
                        name="fechaTicket"
                        labelStart="Fecha inicial:"
                        labelEnd="Fecha final:"
                        labelTo="-"
                        dateFormat={dateFormat}
                        onChange={handlerOnChange}
                        value={initDateRangePicker}
                    />
                </Box>
            </Stack>

            <Grid container>
                <GTIWebDataGrid
                    pageSize={10}
                    rows={tickets}
                    columns={columns}
                    getRowId={(r) => r.id}
                    disableColumnMenu
					disableColumnSelector
					disableSelectionOnClick
                    detailPanelColumnsSchema={columnsPanel}
                    detailPanelContent={detailPanelContentProp}
                    isLoading={isLoading}
                />
            </Grid>

        </HomePageLayout>
    );
};

export default HomePage;